import { Injectable } from "@angular/core";
import { Theme } from "../../models/Theme.enum";

@Injectable()
export class ThemeSwitchService {

	ngOnInit() {
		this.initializeAppTheme();
	}

	/**
	 * 
	 * @param theme theme to be added to body tag
	 * @returns void
	 */
	public addTheme(theme: Theme): void {
		document.body.setAttribute("application-theme", theme);
		this.storeTheme(theme);
	}

	/**
	 * initialize theme for App
	 */
	public initializeAppTheme() {
		this.addTheme(this.getTheme());
	}

	/**
	 * get theme based on value stored in local storage
	 * @returns Theme
	 */
	public getTheme(): Theme {
		let theme: Theme;
		switch (this.getThemeFromStorage()) {
			case Theme.DARK:
				theme = Theme.DARK;
				break;
			case Theme.LIGHT:
				theme = Theme.LIGHT;
				break;
			default:
				theme = Theme.DARK;
				break;
		}
		return theme;
	}

	/**
	 * store theme in local storage
	 * @param theme theme to be stored in local storage
	 */
	private storeTheme(theme: Theme): void {
		localStorage.setItem("APP_THEME", theme);
	}

	/**
	 * get theme from local storage
	 * @returns theme value stored in local storage
	 */
	private getThemeFromStorage(): string {
		return localStorage.getItem("APP_THEME");
	}

	//remove old theme and apply new theme
	public changeTheme(theme: Theme): void {
		document.body.setAttribute("application-theme", theme);
		this.removeThemeFromStorage();
		this.storeTheme(theme);
	}
	// remove theme from local storage
	private removeThemeFromStorage(): void {
		localStorage.removeItem("APP_THEME");
	}
	// remove applied theme
	public removeTheme(): void {
		document.body.removeAttribute("application-theme");
		this.removeThemeFromStorage();
	}
}
